import React, { useState } from "react";
import AddContractDialog from "./AddContractDialog.js";
import SelectContractDialog from "./SelectContractDialog.js";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import CustomDialog from "components/CustomDialog/CustomDialog.js";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import EditButton from "components/CustomButtons/EditButton";

export default function UploadContractDialog(props) {
  const [open, setOpen] = useState(false);
  const [isNewContract, setIsNewContract] = useState();

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (value) => {
    setIsNewContract(value);
  };
  return (
    <CustomDialog
      id="addContract"
      handleClose={handleClose}
      open={open}
      maxWidth="md"
      dialogTitle="Choix du contrat"
      dialogContent={
        <>
          {isNewContract == undefined && (
            <GridContainer>
              <GridItem xs={12} sm={12} md={6} lg={6}>
              <EditButton handleSubmit={() => handleClick(false)}>Selectionner un contrat existant</EditButton>
              <EditButton handleSubmit={() => handleClick(true)}>Créer un nouveau contrat</EditButton>
               
              </GridItem>
            </GridContainer>
          )}
          {(isNewContract || isNewContract == false) && (
            <IconButton
              style={{
                color: "#91c241",
              }}
              onClick={() => handleClick(undefined)}
            >
              <KeyboardBackspaceIcon />
            </IconButton>
          )}

          {isNewContract && <AddContractDialog closeModal={handleClose} />}
          {isNewContract == false && (
            <SelectContractDialog closeModal={handleClose} {...props} />
          )}
        </>
      }
      handleClickOpen={handleClickOpen}
      icon={
        <EditIcon
          fontSize="small"
          style={{
            marginRight: "6px",
          }}
        />
      }
      buttonName="Choix du contrat"
      disabled={props.disabled}
    />
  );
}
